import {createListFromObject} from "../components/common/commonUtilities";

export const RecordsPerPage = {
    "5": 5,
    "10": 10,
    "20": 20,
    "All": "All"
};

export const RecordsPerPageList = createListFromObject(RecordsPerPage);